export default __webpack_public_path__ + "static/media/al.6ea23f78.svg";